import { FitnessLevel, GENDER, Goals, ProblemZone } from 'constants/user';

export interface IUpdateUserRequest {
    email?: string;
    date_of_birth?: string;
    gender?: GENDER;
    fitness_level?: FitnessLevel;
    height?: number;
    first_name?: string;
    last_name?: string;
    country?: string;
    password?: string;
    weight?: number;
    localization?: string;
    target_weight?: number;
    units?: UnitTypes;
    target_bodytype?: 'fit' | 'cut' | 'athletic' | 'bulk' | 'shapely';
    phone?: string;
    sendpulse_mailing_active?: boolean;
    consent_marketing?: boolean;
    is_personal_plan?: boolean;
    user_zip_code?: string;
    problem_zones?: ProblemZone[];
}

export interface UpdateUserResponseType extends Omit<UserInfoResponse, 'first_paid_order_created_at'> {
    first_paid_order_created_at?: string;
}

// equal for sign-in, signature and get user responses
export interface UserInfoResponse {
    user_id: number;
    core_id: number;
    email: string;
    name: string;
    last_name: string;
    is_paid: boolean;
    language: string;
    country: string;
    gender: GENDER;
    weight: number;
    height: number;
    date_of_birth: string;
    units: UnitTypes;
    target_weight: number;
    problem_zones: ProblemZone[];
    localization: string;
    target_bodytype: 'cut' | 'bulk' | 'fit' | 'extra_bulk';
    fitness_level: FitnessLevel;
    goal: Goals[];
    current_body: string;
    occasion: string;
    occasion_date: string;
    focus: any[];
    body_image: string;
    analytics: Record<string, any>;
    timezone: string;
    is_password: boolean;
    product_list: null | {
        [product: string]: boolean;
    };
    first_paid_order_created_at: string;
    is_mobile_user: boolean | null;
    app_link: string;
}

// other
export interface DeepLinkData {
    url: string;
}

export interface HashedEmailResp {
    data: string;
}

export enum UnitTypes {
    Imperial = 'imperial',
    Metric = 'metric',
}

export enum UserFeature {
    AllFeatures = 'all_features',
    Plan = 'plan',
    WorkoutBuilder = 'workout_builder',
    GeneralSeries = 'general_series',
    Face = 'face',
    Fatburn = 'fatburn',
    Sevenmin = 'sevenmin',
    Belly = 'belly',
    AllGuides = 'all_guides',
}
